import { useSiteContent } from '@/context/SiteContentContext';
import ImageUploadField from './ImageUploadField';

export default function AdminHeroTab() {
  const { content, updateContent } = useSiteContent();
  const h = content.hero;

  return (
    <div className="space-y-5">
      <h3 className="text-lg font-bold text-gray-900 border-b border-gray-100 pb-3">Hero Section</h3>

      <ImageUploadField
        label="Background Image"
        value={h.bgImage}
        onChange={(v) => updateContent('hero.bgImage', v)}
      />

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Badge Text</label>
        <input
          type="text"
          value={h.badge}
          onChange={(e) => updateContent('hero.badge', e.target.value)}
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500"
        />
      </div>

      <div className="grid grid-cols-1 gap-3">
        {(['headline1', 'headline2', 'headline3'] as const).map((key, i) => (
          <div key={key}>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Headline Line {i + 1}</label>
            <input
              type="text"
              value={h[key]}
              onChange={(e) => updateContent(`hero.${key}`, e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500"
            />
          </div>
        ))}
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Subtext</label>
        <textarea
          value={h.subtext}
          rows={3}
          onChange={(e) => updateContent('hero.subtext', e.target.value)}
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 resize-none"
        />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Primary Button</label>
          <input
            type="text"
            value={h.ctaPrimary}
            onChange={(e) => updateContent('hero.ctaPrimary', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1.5">Secondary Button</label>
          <input
            type="text"
            value={h.ctaSecondary}
            onChange={(e) => updateContent('hero.ctaSecondary', e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500"
          />
        </div>
      </div>
    </div>
  );
}
